import {Badge} from '@/components/ui/badge/Badge'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {StyledPoint} from '@/features/projects/components/progress-status-badge/style'
import {ProjectExtended, ProjectProgressStatus} from '@/features/projects/types'
import {projectProgressStatusToIcon, projectProgressStatusToLabel} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'
import {useOutletContext} from 'react-router-dom'

export const ProgressStatusBadge = ({progressStatus}: {progressStatus: ProjectProgressStatus}) => {
    const {t} = useTranslation()
    const {project} = useOutletContext<{project: ProjectExtended}>()

    if (progressStatus === 'transmitted') return null
    if (progressStatus === 'to_transmit' && project.openingTransmissionAt && project.status !== 'closed') return null

    const Icon = projectProgressStatusToIcon[progressStatus]
    const siarLabel =
        project.openingTransmissionAt && project.status === 'closed'
            ? t('projects:siar_closing_project')
            : t('projects:siar_opening')

    const description: Record<Exclude<ProjectProgressStatus, 'transmitted'>, string> = {
        incomplete: t('projects:verify_missing_data'),
        to_print: t('projects:projects_siar'),
        to_export: siarLabel,
        to_transmit: siarLabel
    }

    return (
        <Flexbox gap={2} align="center">
            <Badge variant={progressStatus === 'incomplete' ? 'orange' : 'neutral'} size="sm" shape="roundedRectangle">
                <Icon />
                {t(projectProgressStatusToLabel[progressStatus])}
            </Badge>
            <Flexbox align="center" justify="center" gap={1}>
                <StyledPoint />
                <Text size="textSm" palette="neutral" shade="600">
                    {description[progressStatus]}
                </Text>
            </Flexbox>
        </Flexbox>
    )
}
